// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__3kect","ScrollX":"Scroll_ScrollX__3FhBZ","ScrollY":"Scroll_ScrollY__2EJ6E"};